// extracted by mini-css-extract-plugin
export default {"Divider":"Divider_Divider__phnbj","Divider-content":"Divider_Divider-content__3XwDI"};